import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import {
	checkIsMobile,
	getCurrency,
	getLanguageLocale,
	stringifyNum,
} from 'shared'
import { SeeAll, Select, TableLegacy } from 'selfServicePortal/components/index'
import MobileTransactions from './MobileTransactions/MobileTransactions'
import { useTransactions } from 'selfServicePortal/hooks/useTransactions'
import TransactionsContext from 'selfServicePortal/contexts/TransactionsContext'

import './DepositTransactions.scss'

interface IDepositTransactions {
	isOverview: boolean
}

const DepositTransactions = ({ isOverview }: IDepositTransactions) => {
	const { t } = useTranslation()
	const isMobile = checkIsMobile()
	const { loadingTransactions } = useContext(TransactionsContext)
	let width = isOverview ? 'w-50' : 'w-100'

	const { getMoreTransactionsFromMonth, tableData, hideShowMore } =
		useTransactions()

	const cols = [t('TransactionDate'), t('Amount'), t('Type')]

	let itemsToRender
	if (tableData && !loadingTransactions) {
		itemsToRender = tableData.map((item: any, key: number) => {
			return (
				<tr key={key}>
					<td>
						{new Date(item.transactionDate).toLocaleDateString(
							getLanguageLocale()
						)}
					</td>
					<td>
						{stringifyNum(item.amount, {
							currency: getCurrency(),
							style: 'currency',
						})}
					</td>
					<td>{item.transactionTypeUiString}</td>
				</tr>
			)
		})
	}

	return (
		<React.Fragment>
			{isMobile ? (
				<MobileTransactions isOverview={isOverview} />
			) : (
				<div className={`deposit-transactions ${width}`}>
					<div className={`fade-in transactions outer-container p-3`}>
						<div className="d-flex justify-content-between">
							<div>{t('LastTransactions')}</div>
							{!isOverview && (
								<Select
									getMoreTransactionsFromMonth={
										getMoreTransactionsFromMonth
									}
								/>
							)}
						</div>
						<TableLegacy columns={cols} data={itemsToRender} />
						<div className="d-flex justify-content-center">
							<SeeAll
								isOverview={isOverview}
								showMore={() =>
									getMoreTransactionsFromMonth(
										tableData[0].transactionDate,
										tableData.length + 10
									)
								}
								hideShowMore={hideShowMore}
							/>
						</div>
					</div>
				</div>
			)}
		</React.Fragment>
	)
}

export default DepositTransactions
